import { toCamelCase } from '~/types/naming';

/*
  バリデーションのレスポンス定義を記載
*/
export type ValidationError = {
  message: string;
  errors: { [key: string]: Array<{ no: string; data: string }> };
};

export type mapError = {
  no: string;
  data: { [key: string]: string };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapToValidationError = (
  e: ValidationError
): { [key: string]: mapError } => {
  const errors = {} as { [key: string]: mapError };
  if (e.errors) {
    for (const k in e.errors) {
      const error = { no: '' } as mapError;
      error.no = e.errors[k][0].no;
      error.data = JSON.parse(e.errors[k][0].data);
      errors[toCamelCase(k)] = error;
    }
  }
  return errors;
};

export const toValidationMessage = (
  template: string,
  name: string,
  data: { [key: string]: string }
): string => {
  let validationMessage = template.replace(':attribute', name);
  for (const key in data) {
    validationMessage = validationMessage.replace(`:${key}`, data[key]);
  }
  return validationMessage;
};
